import HttpRequest from './HttpRequest';

export const getUpcomingConcerts = async () => {
  try {
    const response = await HttpRequest.get('/concerts/upcoming');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getPastConcerts = async () => {
  try {
    const response = await HttpRequest.get('/concerts/past');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
